import config from 'react-global-configuration';

import {
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  setOperationStatus,
} from '@uncinc/react-drupal-core';
import { entityLoaded } from '@uncinc/react-drupal-core/dist/redux/actions/Entity';
import { nodeGetLoaded } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/Node';

import { fetchMessages } from '../../Messages';

// Temporary.
// This is a workaround, because the current setup for making DELETE requests to /node/{{nodeId}} hasn't been
// implemented yet in React Drupal Core.
//
// For more information, see ticket on Monday: ...

export const NODE_GET_LOADED = 'NODE_GET_LOADED';

export const nodeDelete = (nodeId) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('node', 'delete', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/node/${nodeId}?_format=json`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('node', 'delete', UI_OPERATION_STATUS_SUCCESS));
                dispatch(nodeDeleted());
                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('node', 'delete', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('node', 'delete', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const NODE_DELETED = 'NODE_DELETED';
export function nodeDeleted() {
  return {
    type: NODE_DELETED,
  };
}

export const nodeAdd = (values) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    dispatch(setOperationStatus('node', 'add', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/node?_format=json`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                dispatch(setOperationStatus('node', 'add', UI_OPERATION_STATUS_SUCCESS));

                // Fetch messages for possible new badges.
                dispatch(fetchMessages());

                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              dispatch(setOperationStatus('node', 'add', UI_OPERATION_STATUS_ERROR));
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('node', 'add', UI_OPERATION_STATUS_ERROR));
          reject(error);
        });
    });
  };
};

export const nodeEdit = (nid, values) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;
    const currentEntityId = getState().getIn(['entity', 'entityId'], '');
    const currentEntityType = getState().getIn(['entity', 'entityType'], '');
    const currentEntityCanonical = getState().getIn(['entity', 'canonical'], '');

    dispatch(setOperationStatus('node', 'edit', UI_OPERATION_STATUS_REQUEST));

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/node/${nid}?_format=json`, {
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify(values),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error();
              }

              return response.json();
            })
            .then((response) => {
              dispatch(nodeGetLoaded(nid, response));

              // Only reload the entity if the current entity id and type in the state
              // are equal to the edited entity id and type, otherwise we might be
              // loading in the wrong entity.
              if (currentEntityId === String(nid) && currentEntityType === 'node') {
                dispatch(entityLoaded('node', nid, currentEntityCanonical.replace(API_URL, '')));
              }

              dispatch(setOperationStatus('node', 'edit', UI_OPERATION_STATUS_SUCCESS));
              resolve(response);
            })
            .catch((error) => {
              dispatch(setOperationStatus('node', 'edit', UI_OPERATION_STATUS_ERROR));
              console.log('error', error);
              reject(error);
            });
        })
        .catch((error) => {
          dispatch(setOperationStatus('node', 'edit', UI_OPERATION_STATUS_ERROR));
          console.log('error', error);
          reject(error);
        });
    });
  };
};
